import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isTkDebugEnabled, isTkTuneEnabled } from '@/lib/ui/queryFlags';

export const DevQueryHud = () => {
  const location = useLocation();
  const [flags, setFlags] = useState({ tkTune: false, tkDebug: false });

  useEffect(() => {
    setFlags({
      tkTune: isTkTuneEnabled(),
      tkDebug: isTkDebugEnabled(),
    });
  }, [location.search]);

  if (!import.meta.env.DEV) return null;
  if (!flags.tkDebug && !flags.tkTune) return null;

  return (
    <div className="pointer-events-none fixed bottom-3 left-3 z-[9999] rounded-full bg-black/70 px-3 py-1 text-[11px] text-white shadow">
      tkTune: {flags.tkTune ? 'ON' : 'OFF'} | path: {location.pathname} | search:{' '}
      {location.search || '(none)'}
    </div>
  );
};
